import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../modal/withModal';
import PhotoDownload from './PhotoDownload';

export const PHOTO_DOWNLOAD_MODAL = 'modal/photo-download';

const propTypes = {
  onRequestClose: PropTypes.func,
  actionProps: PropTypes.shape({
    name: PropTypes.string,
    photoDownloadCreateInput: PropTypes.shape({
      photo_ids: PropTypes.shape({
        select_all: PropTypes.bool,
        selected_ids: PropTypes.array,
        ignored_ids: PropTypes.array,
      }),
    }),
    totalPhotos: PropTypes.number,
  }),
};

const PhotoDownloadModal = ({ onRequestClose, actionProps = {}, ...props }) => {
  return <PhotoDownload onClose={onRequestClose} {...props} {...actionProps} />;
};

PhotoDownloadModal.propTypes = propTypes;

export default withModal(PhotoDownloadModal, {
  name: PHOTO_DOWNLOAD_MODAL,
  size: 'sm',
  contentLabel: 'Download your photos',
});
